module.exports = __webpack_public_path__ + "static/img/knowledge.e2d605be.svg";